import { Action, handleActions } from 'redux-actions'
import { NotificationDto, NotificationRow, UserNotificationDto } from '../../../services/api.types'
import {
  getUserNotifications,
  getUserNotificationsFail,
  getUserNotificationsSuccess,
  markUserNotificationRead,
} from './InboxActions'

class State {
  list: UserNotificationDto[] = []
  isLoading: boolean = false
}

export const inbox = handleActions<State, any>(
  {
    [String(getUserNotifications)]: (state: State): State => ({
      ...state,
      isLoading: true,
    }),
    [String(getUserNotificationsSuccess)]: (state: State, action: Action<UserNotificationDto[]>): State => ({
      ...state,
      list: action.payload,
      isLoading: false,
    }),
    [String(getUserNotificationsFail)]: (state: State): State => ({
      ...state,
      isLoading: false,
    }),
  },
  new State(),
)

export { State as InboxState }
